import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, TargetIcon, BarChart3Icon, CheckSquareIcon, ClipboardListIcon, UserIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <FileTextIcon className="w-6 h-6 text-emerald-400" data-id="element-105" />,
    title: 'Guía PDF El Protocolo Andromeda',
    desc: 'El sistema paso a paso para configurar campañas Broad que se auto-optimizan.'
  }, {
    icon: <TargetIcon className="w-6 h-6 text-emerald-400" data-id="element-106" />,
    title: 'Framework de Espejo',
    desc: 'Cómo escribir ganchos (Hooks) que detienen el scroll del cliente ideal y repelen al curioso.'
  }, {
    icon: <BarChart3Icon className="w-6 h-6 text-emerald-400" data-id="element-107" />,
    title: 'Estructura Técnica 1-3-2',
    desc: 'La configuración exacta de campaña CBO para escalar sin romper el algoritmo.'
  }, {
    icon: <BarChart3Icon className="w-6 h-6 text-emerald-400" data-id="element-108" />,
    title: 'Métricas de Segunda Generación',
    desc: 'Aprende a leer el Hook Rate y el Hold Rate para saber exactamente cuándo apagar o escalar.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6 text-emerald-400" data-id="element-109" />,
    title: 'Master Checklist Pre-Lanzamiento',
    desc: 'Los 12 puntos críticos para asegurar que tu campaña no falle antes de empezar.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-emerald-400" data-id="element-110" />,
    title: 'Hoja de Trabajo de Identidad',
    desc: 'El ejercicio para extraer el dolor subconsciente de tu cliente.'
  }];
  return <section className="py-20 px-4" data-id="element-111">
      <div className="max-w-5xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-113">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-114">
            Lo que obtienes hoy
          </h2>
          <p className="text-xl text-slate-400" data-id="element-115">
            Todo lo que necesitas para lanzar tu campaña hoy mismo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-116">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-[#161b22] border border-white/5 rounded-2xl p-6 hover:border-emerald-500/30 transition-colors group" data-id="element-117">
              <div className="flex items-start gap-4" data-id="element-118">
                <div className="bg-emerald-500/10 p-3 rounded-xl group-hover:bg-emerald-500/20 transition-colors" data-id="element-119">
                  {item.icon}
                </div>
                <div data-id="element-120">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-121">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-122">{item.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}